import { Fragment } from 'react';
import '../../styles.css';

import { translate } from '@avalara/bat-apps-shared/i18n';
const SohoInfo = () => (
  <Fragment>
    <h3 className='message-title'>{translate('shared.headings.dont-see-your-app')}</h3>
    <div className='search-container'>
      <div>
        <p>
          {translate('shared.general.avalara-connects-with-700-marketplaces-and-browse-integrations', {
            integrationsLink: (chunks) => (
              <a
                href='https://www.avalara.com/us/en/products/integrations.html'
                target='_blank'
                rel='noopener noreferrer'
              >
                {chunks}
              </a>
            ),
          })}
        </p>
      </div>
    </div>
    <div />
  </Fragment>
);

export default SohoInfo;
